import Vue from "vue";
const humanizeDuration = require("humanize-duration");

Vue.filter("currency", function(number) {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  });

  var formatted = formatter.format(number); // "$1,000.00"

  return formatted;
});

Vue.filter("humanize", function(n) {
  return humanizeDuration(n);
});

Vue.filter("ordinal", function(num) {
  const int = parseInt(num),
    digits = [int % 10, int % 100],
    ordinals = ["st", "nd", "rd", "th"],
    oPattern = [1, 2, 3, 4],
    tPattern = [11, 12, 13, 14, 15, 16, 17, 18, 19];
  return oPattern.includes(digits[0]) && !tPattern.includes(digits[1])
    ? int + ordinals[digits[0] - 1]
    : int + ordinals[3];
});

Vue.filter("title", function(string) {
  if (!string) return "";

  return string
    .toLowerCase()
    .split(" ")
    .map(function(word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
});

Vue.filter("carriageToBr", function(string) {
  if (!string) return "";

  return string.replace(/(?:\r\n|\r|\n)/g, "<br />");
});

Vue.filter("source", function(string) {
  if (!string) return "";

  if (string == "PAYMENTPLAN") return "Payment Plan";
  if (string == "MEMBERSHIP") return "Membership";
  if (string == "VIRTUALTERMINAL") return "Virtual Terminal";
  if (string == "TERMINAL") return "Terminal";
  if (string == "TEXTTOPAY") return "Text To Pay";
  if (string == "PAYMENTPAGE") return "Payment Page";
});

Vue.filter("phonenumber", function(str) {
  //Filter only numbers from the input
  let cleaned = ("" + str).replace(/\D/g, "");

  //Check if the input is of correct length
  let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return "(" + match[1] + ") " + match[2] + "-" + match[3];
  }

  return null;
});

Vue.filter("lowercase", function(str) {
  //Filter only numbers from the input
  return str.toLowerCase();
});
